/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-03-12 12:44:23
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
  server: {
    ANALYZE: z
      .enum(['true', 'false'])
      .optional()
      .transform((value) => value === 'true'),
    NODEJS_ZEELOOL_SERVER_API_BASE_URL: z.string(),
    REVALIDATE_SECRET: z.string(),
    SERVER_LOG_LEVEL: z.enum(['debug', 'info', 'warn', 'error']),
    REDIS_URL: z.string(),
    DING_BOT_ACCESS_TOKEN: z.string().optional(),
  },
  client: {
    NEXT_PUBLIC_COMPANY_NAME: z.string(),
    NEXT_PUBLIC_COMPANY_ADDRESS: z.string(),
    NEXT_PUBLIC_COMPANY_EIN: z.string(),
    NEXT_PUBLIC_ALLOWED_FRAME_ORIGIN: z.string(),
    NEXT_PUBLIC_SITE_ID: z.string().optional(),
    NEXT_PUBLIC_SENSORS_PUB_PLATFORM_NAME: z.string().optional(),
    NEXT_PUBLIC_SENSORS_PUB_WAP_PLATFORM_NAME: z.string().optional(),
    NEXT_PUBLIC_HELP_CENTER_URL: z.string().optional(),
    NEXT_PUBLIC_QUEST_COUPON_ID: z.string().optional(),
    NEXT_PUBLIC_ZEELOOL_SERVER_API_BASE_URL: z.string(),
    NEXT_PUBLIC_PARENT_IFRAME_URL: z.string(),
    NEXT_PUBLIC_ENV: z.enum(['local', 'dev', 'test', 'uat', 'production']),
    NEXT_PUBLIC_PARENT_IFRAME_TOKEN: z.string().optional(),
    NEXT_PUBLIC_SENSORS_SERVER_URL: z.string(),
    NEXT_PUBLIC_SENSORS_SHOW_LOG: z
      .enum(['true', 'false'])
      .optional()
      .transform((value) => value === 'true'),
    NEXT_PUBLIC_S3_URL: z.string(),
    NEXT_PUBLIC_S3_FOLDER: z.string(),
    NEXT_PUBLIC_SITE_NAME: z.enum(['de', 'us', 'ca', 'fr', 'uk']).optional(),
    NEXT_PUBLIC_DEFAULT_CURRENCY: z.enum(['EUR', 'USD', 'CAD', 'GBP']).optional(),
    NEXT_PUBLIC_S3_FULL_URL: z.string(),
    NEXT_PUBLIC_PAYPAL_CLIENT_ID: z.string(),
    NEXT_PUBLIC_AYDEN_CLIENT_KEY: z.string(),
    NEXT_PUBLIC_AYDEN_ENVIROMENT: z.enum(['test', 'live']),
    NEXT_PUBLIC_KLARNA_ENV: z.enum(['production']),
    NEXT_PUBLIC_KLARNA_CLIENT_ID_US: z.string(),
    NEXT_PUBLIC_KLARNA_CLIENT_ID_EU: z.string(),
    NEXT_PUBLIC_ENABLE_GA4: z.enum(['true', 'false']),
    NEXT_PUBLIC_GA4_MEASUREMENT_ID: z.string(),
    NEXT_PUBLIC_GA4_AD_ID1: z.string().optional(),
    NEXT_PUBLIC_GA4_AD_ID2: z.string().optional(),
    NEXT_PUBLIC_ENABLE_APPLOVIN: z.enum(['true', 'false']),
    NEXT_PUBLIC_APPLOVIN_KEY: z.string().optional(),
    NEXT_PUBLIC_ENABLE_BING: z.enum(['true', 'false']),
    NEXT_PUBLIC_BING_ID: z.string().optional(),
    NEXT_PUBLIC_ENABLE_CRITEO: z.enum(['true', 'false']),
    NEXT_PUBLIC_CRITEO_ID: z.string().optional(),
    NEXT_PUBLIC_ENABLE_FACEBOOK: z.enum(['true', 'false']),
    NEXT_PUBLIC_FACEBOOK_ID: z.string().optional(),
    NEXT_PUBLIC_ENABLE_PEPPERJAM: z.enum(['true', 'false']),
    NEXT_PUBLIC_PEPPERJAM_ID: z.string().optional(),
    NEXT_PUBLIC_ENABLE_SNAPCHAT: z.enum(['true', 'false']),
    NEXT_PUBLIC_ENABLE_SNAPCHAT_CONVERSION: z.enum(['true', 'false']),
    NEXT_PUBLIC_SNAPCHAT_KEY: z.string().optional(),
    NEXT_PUBLIC_ENABLE_TT_PIXEL: z.enum(['true', 'false']),
    NEXT_PUBLIC_TIKTOK_PIXEL_KEY: z.string().optional(),
    NEXT_PUBLIC_ENABLE_TTDPIXEL: z.enum(['true', 'false']),
    NEXT_PUBLIC_TTDPIXEL_KEY: z.string().optional(),
    NEXT_PUBLIC_TTDPIXEL_TAG_IDS: z
      .string()
      .optional()
      .transform((value) => (value ? value.split(',').map((s) => s.trim()) : [])),
    NEXT_PUBLIC_ENABLE_TWITTER: z.enum(['true', 'false']),
    NEXT_PUBLIC_TWITTER_KEYS: z
      .string()
      .optional()
      .transform((value) => (value ? value.split(',').map((s) => s.trim()) : [])),
    NEXT_PUBLIC_ENABLE_EMARSYS: z.enum(['true', 'false']),
    NEXT_PUBLIC_EMARSYS_DOMAIN_CODE: z.string().optional(),
    NEXT_PUBLIC_EMARSYS_DEFAULT_NOTIFICATION_TITLE: z.string().optional(),
    NEXT_PUBLIC_EMARSYS_DEFAULT_NOTIFICATION_ICON: z.string().optional(),
    NEXT_PUBLIC_EMARSYS_APPLICATION_SERVER_PUBLIC_KEY: z.string().optional(),
    NEXT_PUBLIC_EMARSYS_SCARAB_JS_API_URL: z.string().optional(),
    NEXT_PUBLIC_ENABLE_ONETRUST: z.enum(['true', 'false']).transform((value) => {
      // 在本地、开发环境和测试环境中强制禁用 OneTrust
      const currentEnv = process.env.NEXT_PUBLIC_ENV;
      if (currentEnv === 'local' || currentEnv === 'dev' || currentEnv === 'test') {
        return 'false';
      }
      return value;
    }),
    NEXT_PUBLIC_ADDRESS_COUNTRY_ID: z.string(),
    NEXT_PUBLIC_ADDRESS_COUNTRY: z.string(),
    NEXT_PUBLIC_ADDRESS_TEL_CODE: z.string(),
    NEXT_PUBLIC_ADDRESS_TEL_COUNTRY: z.string(),
    NEXT_PUBLIC_HELP_CENTER_PATH: z.string(),
    NEXT_PUBLIC_COMPONENT_DATEPICKER_ORDER: z.enum(['DMY', 'MDY']),
    NEXT_PUBLIC_ZING_MODULE_ENABLE: z.enum(['true', 'false']),
    NEXT_PUBLIC_ACCOUNT_ENABLE_SKINTONES: z.enum(['true', 'false']),
    NEXT_PUBLIC_KOC_MODULE_ENABLE: z.enum(['true', 'false']),
    NEXT_PUBLIC_DATE_FORMAT: z.string(),
    NEXT_PUBLIC_SHOW_QUESTIONNAIRES_BANNER: z.enum(['true', 'false']),
    NEXT_PUBLIC_PAY_CENTER_ENV: z.enum(['test', 'prod']),
    NEXT_PUBLIC_BASE_GOODS_LIST_ID: z.string(),
    NEXT_PUBLIC_FB_GROUP: z.string(),
    NEXT_PUBLIC_LOCALE_DEFAULT_TELCODE: z.string(),
    NEXT_PUBLIC_VIP_LAST_UPGRADE_DATE_FORMAT: z.string(),
    NEXT_PUBLIC_FOOTER_SHOW_TEL: z.enum(['true', 'false']).optional(),
    NEXT_PUBLIC_FB: z.string(),
    NEXT_PUBLIC_YTB: z.string(),
    NEXT_PUBLIC_INS: z.string(),
    NEXT_PUBLIC_X: z.string(),
    NEXT_PUBLIC_PIN: z.string(),
    NEXT_PUBLIC_TT: z.string(),
    NEXT_PUBLIC_WAP_SHOW_FB_GROUP: z.enum(['true', 'false']).optional(),
    NEXT_PUBLIC_WEB_SHOW_FB_GROUP: z.enum(['true', 'false']).optional(),
    NEXT_PUBLIC_FB_GROUP_IMG: z.string(),
    NEXT_PUBLIC_SHOW_DOWNLOAD_APP: z.enum(['true', 'false']).optional(),
    NEXT_PUBLIC_PD_RULE_PDF: z.string(),
    NEXT_PUBLIC_ZEELOOL_REWARDS_SHOP_NOW_BTN: z.string(),
    NEXT_PUBLIC_ZEELOOL_REWARDS_SHOP_NOW_LINK: z.string(),
    NEXT_PUBLIC_MARKET_EMAIL: z.string(),
    NEXT_PUBLIC_COOKIE_TARGET: z.string(),
    NEXT_PUBLIC_PAY_CENTER_SITE_NAME: z.string(),
    NEXT_PUBLIC_SHOW_KLARNA: z.enum(['true', 'false']).optional(),
    NEXT_PUBLIC_SITE_LANG: z.enum(['en', 'de', 'fr']),
    NEXT_PUBLIC_FACEBOOK_MESSAGE_APP_ID: z.string(),
    NEXT_PUBLIC_ENABLE_CLIENT_LOGGER: z.enum(['true', 'false']),
    NEXT_PUBLIC_LOG_LEVEL: z.enum(['debug', 'info', 'warn', 'error']),
    NEXT_PUBLIC_LOG_PREFIX: z.string(),
    NEXT_PUBLIC_GOOGLE_BADGE_ID: z.string(),
    NEXT_PUBLIC_ENABLE_IMPACT_RADIUS: z.enum(['true', 'false']),
    NEXT_PUBLIC_SHOW_CONTACT_US: z.enum(['true', 'false']).optional(),
    NEXT_PUBLIC_SHOW_AFTER_PAY: z.enum(['true', 'false']).optional(),
    NEXT_PUBLIC_TONG_DUN_PARTNER_ID: z.string(),
    NEXT_PUBLIC_TONG_DUN_BASE_URL: z.string(),
    NEXT_PUBLIC_TONG_DUN_SITE_KEY: z.string(),
    NEXT_PUBLIC_ENABLE_GOOGLE_TRANSLATE: z.enum(['true', 'false']),
    NEXT_PUBLIC_ENABLE_RTB_HOUSE: z.enum(['true', 'false']),
    NEXT_PUBLIC_RTB_HOUSE_ID: z.string().optional(),
    NEXT_PUBLIC_RTB_HOUSE_DATA_CENTER: z.string().optional(),
    NEXT_PUBLIC_ENCRYPT_CODE: z.string(),
    NEXT_PUBLIC_ENABLE_AWIN: z.enum(['true', 'false']),
    NEXT_PUBLIC_AWS_WAF_CHALLENGE_SDK_URL: z.string().optional(),
    NEXT_PUBLIC_AWS_WAF_CAPTCHA_SDK_URL: z.string().optional(),
    NEXT_PUBLIC_AWS_WAF_API_KEY: z.string().optional(),
    NEXT_PUBLIC_ENABLE_AWS_WAF: z.enum(['true', 'false']).optional(),
    NEXT_PUBLIC_AWIN_MERCHANT: z.string().optional(),
    NEXT_PUBLIC_ZENDESK_KEY: z.string(),
    NEXT_PUBLIC_ENABLE_CONSENT_MANAGER: z.enum(['true', 'false']),
    NEXT_PUBLIC_CONSENT_MANAGER_CDID: z.string().optional(),
    NEXT_PUBLIC_GA4_PURCHASE: z.string(),
    NEXT_PUBLIC_GA4_ADD_TO_CART: z.string(),
    NEXT_PUBLIC_GA4_GOODS_DETAIL: z.string(),
    NEXT_PUBLIC_FULL_LOCALE: z.string(),
    NEXT_PUBLIC_FULL_SITE_NAME: z.string(),
    NEXT_PUBLIC_FULL_URL: z.string(),
    NEXT_PUBLIC_URL: z.string(),
    NEXT_PUBLIC_SUPPORT_EMAIL: z.string(),
    NEXT_PUBLIC_AFFILIATE_EMAIL: z.string(),
    NEXT_PUBLIC_PUBLIC_RELATION_EMAIL: z.string(),
    NEXT_PUBLIC_CUSTOMER_SERVICE_TIME: z.string(),
    NEXT_PUBLIC_HAS_APP: z.enum(['true', 'false']),
    NEXT_PUBLIC_ENABLE_SHAREASALE: z.enum(['true', 'false']),
    NEXT_PUBLIC_SHAREASALE_MERCHANT_ID: z.string().optional(),
    NEXT_PUBLIC_GOOGLE_PAY_MERCHANT_ID: z.string(),
    NEXT_PUBLIC_GOOGLE_GATEWAY_MERCHANT_ID: z.string(),
    NEXT_PUBLIC_APPLE_PAY_MERCHANT_ID: z.string(),
    NEXT_PUBLIC_TWITTER_NAME: z.string(),
    // arms用户体验监控sdk
    NEXT_PUBLIC_ARMS_PID: z.string().optional(),
    NEXT_PUBLIC_ARMS_ENDPOINT: z.string().optional(),
    NEXT_PUBLIC_ENABLE_ARMS: z.enum(['true', 'false']),
    NEXT_PUBLIC_FULL_COUNTRY_NAME: z.string(),
    NEXT_PUBLIC_KLARNA_TYPE: z.enum(['klarna_account', 'klarna']),
  },
  runtimeEnv: {
    NEXT_PUBLIC_COMPANY_NAME: process.env.NEXT_PUBLIC_COMPANY_NAME,
    NEXT_PUBLIC_COMPANY_ADDRESS: process.env.NEXT_PUBLIC_COMPANY_ADDRESS,
    NEXT_PUBLIC_COMPANY_EIN: process.env.NEXT_PUBLIC_COMPANY_EIN,
    NEXT_PUBLIC_ALLOWED_FRAME_ORIGIN: process.env.NEXT_PUBLIC_ALLOWED_FRAME_ORIGIN,
    NEXT_PUBLIC_SITE_ID: process.env.NEXT_PUBLIC_SITE_ID,
    NEXT_PUBLIC_SENSORS_PUB_PLATFORM_NAME: process.env.NEXT_PUBLIC_SENSORS_PUB_PLATFORM_NAME,
    NEXT_PUBLIC_SENSORS_PUB_WAP_PLATFORM_NAME:
      process.env.NEXT_PUBLIC_SENSORS_PUB_WAP_PLATFORM_NAME,
    NEXT_PUBLIC_HELP_CENTER_URL: process.env.NEXT_PUBLIC_HELP_CENTER_URL,
    NEXT_PUBLIC_QUEST_COUPON_ID: process.env.NEXT_PUBLIC_QUEST_COUPON_ID,
    ANALYZE: process.env.ANALYZE,
    REVALIDATE_SECRET: process.env.REVALIDATE_SECRET,
    SERVER_LOG_LEVEL: process.env.SERVER_LOG_LEVEL,
    REDIS_URL: process.env.REDIS_URL,
    DING_BOT_ACCESS_TOKEN: process.env.DING_BOT_ACCESS_TOKEN,
    NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
    NEXT_PUBLIC_ZEELOOL_SERVER_API_BASE_URL: process.env.NEXT_PUBLIC_ZEELOOL_SERVER_API_BASE_URL,
    NEXT_PUBLIC_PARENT_IFRAME_URL: process.env.NEXT_PUBLIC_PARENT_IFRAME_URL,
    NEXT_PUBLIC_PARENT_IFRAME_TOKEN: process.env.NEXT_PUBLIC_PARENT_IFRAME_TOKEN,
    NEXT_PUBLIC_SENSORS_SERVER_URL: process.env.NEXT_PUBLIC_SENSORS_SERVER_URL,
    NEXT_PUBLIC_SENSORS_SHOW_LOG: process.env.NEXT_PUBLIC_SENSORS_SHOW_LOG,
    NODEJS_ZEELOOL_SERVER_API_BASE_URL: process.env.NODEJS_ZEELOOL_SERVER_API_BASE_URL,
    NEXT_PUBLIC_S3_URL: process.env.NEXT_PUBLIC_S3_URL,
    NEXT_PUBLIC_S3_FULL_URL: process.env.NEXT_PUBLIC_S3_FULL_URL,
    NEXT_PUBLIC_SITE_NAME: process.env.NEXT_PUBLIC_SITE_NAME,
    NEXT_PUBLIC_DEFAULT_CURRENCY: process.env.NEXT_PUBLIC_DEFAULT_CURRENCY,
    NEXT_PUBLIC_PAYPAL_CLIENT_ID: process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID,
    NEXT_PUBLIC_AYDEN_CLIENT_KEY: process.env.NEXT_PUBLIC_AYDEN_CLIENT_KEY,
    NEXT_PUBLIC_AYDEN_ENVIROMENT: process.env.NEXT_PUBLIC_AYDEN_ENVIROMENT,
    NEXT_PUBLIC_KLARNA_ENV: process.env.NEXT_PUBLIC_KLARNA_ENV,
    NEXT_PUBLIC_KLARNA_CLIENT_ID_US: process.env.NEXT_PUBLIC_KLARNA_CLIENT_ID_US,
    NEXT_PUBLIC_KLARNA_CLIENT_ID_EU: process.env.NEXT_PUBLIC_KLARNA_CLIENT_ID_EU,
    NEXT_PUBLIC_ENABLE_GA4: process.env.NEXT_PUBLIC_ENABLE_GA4,
    NEXT_PUBLIC_GA4_MEASUREMENT_ID: process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID,
    NEXT_PUBLIC_GA4_AD_ID1: process.env.NEXT_PUBLIC_GA4_AD_ID1,
    NEXT_PUBLIC_GA4_AD_ID2: process.env.NEXT_PUBLIC_GA4_AD_ID2,
    NEXT_PUBLIC_TIKTOK_PIXEL_KEY: process.env.NEXT_PUBLIC_TIKTOK_PIXEL_KEY,
    NEXT_PUBLIC_ENABLE_APPLOVIN: process.env.NEXT_PUBLIC_ENABLE_APPLOVIN,
    NEXT_PUBLIC_APPLOVIN_KEY: process.env.NEXT_PUBLIC_APPLOVIN_KEY,
    NEXT_PUBLIC_ENABLE_BING: process.env.NEXT_PUBLIC_ENABLE_BING,
    NEXT_PUBLIC_BING_ID: process.env.NEXT_PUBLIC_BING_ID,
    NEXT_PUBLIC_ENABLE_CRITEO: process.env.NEXT_PUBLIC_ENABLE_CRITEO,
    NEXT_PUBLIC_CRITEO_ID: process.env.NEXT_PUBLIC_CRITEO_ID,
    NEXT_PUBLIC_ENABLE_FACEBOOK: process.env.NEXT_PUBLIC_ENABLE_FACEBOOK,
    NEXT_PUBLIC_FACEBOOK_ID: process.env.NEXT_PUBLIC_FACEBOOK_ID,
    NEXT_PUBLIC_ENABLE_PEPPERJAM: process.env.NEXT_PUBLIC_ENABLE_PEPPERJAM,
    NEXT_PUBLIC_PEPPERJAM_ID: process.env.NEXT_PUBLIC_PEPPERJAM_ID,
    NEXT_PUBLIC_ENABLE_SNAPCHAT: process.env.NEXT_PUBLIC_ENABLE_SNAPCHAT,
    NEXT_PUBLIC_ENABLE_SNAPCHAT_CONVERSION: process.env.NEXT_PUBLIC_ENABLE_SNAPCHAT_CONVERSION,
    NEXT_PUBLIC_SNAPCHAT_KEY: process.env.NEXT_PUBLIC_SNAPCHAT_KEY,
    NEXT_PUBLIC_ENABLE_TT_PIXEL: process.env.NEXT_PUBLIC_ENABLE_TT_PIXEL,
    NEXT_PUBLIC_ENABLE_TTDPIXEL: process.env.NEXT_PUBLIC_ENABLE_TTDPIXEL,
    NEXT_PUBLIC_TTDPIXEL_KEY: process.env.NEXT_PUBLIC_TTDPIXEL_KEY,
    NEXT_PUBLIC_TTDPIXEL_TAG_IDS: process.env.NEXT_PUBLIC_TTDPIXEL_TAG_IDS,
    NEXT_PUBLIC_ENABLE_TWITTER: process.env.NEXT_PUBLIC_ENABLE_TWITTER,
    NEXT_PUBLIC_TWITTER_KEYS: process.env.NEXT_PUBLIC_TWITTER_KEYS,
    NEXT_PUBLIC_ENABLE_EMARSYS: process.env.NEXT_PUBLIC_ENABLE_EMARSYS,
    NEXT_PUBLIC_EMARSYS_DOMAIN_CODE: process.env.NEXT_PUBLIC_EMARSYS_DOMAIN_CODE,
    NEXT_PUBLIC_EMARSYS_DEFAULT_NOTIFICATION_TITLE:
      process.env.NEXT_PUBLIC_EMARSYS_DEFAULT_NOTIFICATION_TITLE,
    NEXT_PUBLIC_EMARSYS_DEFAULT_NOTIFICATION_ICON:
      process.env.NEXT_PUBLIC_EMARSYS_DEFAULT_NOTIFICATION_ICON,
    NEXT_PUBLIC_EMARSYS_APPLICATION_SERVER_PUBLIC_KEY:
      process.env.NEXT_PUBLIC_EMARSYS_APPLICATION_SERVER_PUBLIC_KEY,
    NEXT_PUBLIC_EMARSYS_SCARAB_JS_API_URL: process.env.NEXT_PUBLIC_EMARSYS_SCARAB_JS_API_URL,
    NEXT_PUBLIC_ENABLE_ONETRUST: process.env.NEXT_PUBLIC_ENABLE_ONETRUST,
    NEXT_PUBLIC_ADDRESS_COUNTRY_ID: process.env.NEXT_PUBLIC_ADDRESS_COUNTRY_ID,
    NEXT_PUBLIC_ADDRESS_COUNTRY: process.env.NEXT_PUBLIC_ADDRESS_COUNTRY,
    NEXT_PUBLIC_ADDRESS_TEL_CODE: process.env.NEXT_PUBLIC_ADDRESS_TEL_CODE,
    NEXT_PUBLIC_ADDRESS_TEL_COUNTRY: process.env.NEXT_PUBLIC_ADDRESS_TEL_COUNTRY,
    NEXT_PUBLIC_HELP_CENTER_PATH: process.env.NEXT_PUBLIC_HELP_CENTER_PATH,
    NEXT_PUBLIC_COMPONENT_DATEPICKER_ORDER: process.env.NEXT_PUBLIC_COMPONENT_DATEPICKER_ORDER,
    NEXT_PUBLIC_ZING_MODULE_ENABLE: process.env.NEXT_PUBLIC_ZING_MODULE_ENABLE,
    NEXT_PUBLIC_ACCOUNT_ENABLE_SKINTONES: process.env.NEXT_PUBLIC_ACCOUNT_ENABLE_SKINTONES,
    NEXT_PUBLIC_KOC_MODULE_ENABLE: process.env.NEXT_PUBLIC_KOC_MODULE_ENABLE,
    NEXT_PUBLIC_DATE_FORMAT: process.env.NEXT_PUBLIC_DATE_FORMAT,
    NEXT_PUBLIC_SHOW_QUESTIONNAIRES_BANNER: process.env.NEXT_PUBLIC_SHOW_QUESTIONNAIRES_BANNER,
    NEXT_PUBLIC_PAY_CENTER_ENV: process.env.NEXT_PUBLIC_PAY_CENTER_ENV,
    NEXT_PUBLIC_BASE_GOODS_LIST_ID: process.env.NEXT_PUBLIC_BASE_GOODS_LIST_ID,
    NEXT_PUBLIC_FB_GROUP: process.env.NEXT_PUBLIC_FB_GROUP,
    NEXT_PUBLIC_LOCALE_DEFAULT_TELCODE: process.env.NEXT_PUBLIC_LOCALE_DEFAULT_TELCODE,
    NEXT_PUBLIC_VIP_LAST_UPGRADE_DATE_FORMAT: process.env.NEXT_PUBLIC_VIP_LAST_UPGRADE_DATE_FORMAT,
    NEXT_PUBLIC_FOOTER_SHOW_TEL: process.env.NEXT_PUBLIC_FOOTER_SHOW_TEL,
    NEXT_PUBLIC_FB: process.env.NEXT_PUBLIC_FB,
    NEXT_PUBLIC_YTB: process.env.NEXT_PUBLIC_YTB,
    NEXT_PUBLIC_INS: process.env.NEXT_PUBLIC_INS,
    NEXT_PUBLIC_X: process.env.NEXT_PUBLIC_X,
    NEXT_PUBLIC_PIN: process.env.NEXT_PUBLIC_PIN,
    NEXT_PUBLIC_TT: process.env.NEXT_PUBLIC_TT,
    NEXT_PUBLIC_WAP_SHOW_FB_GROUP: process.env.NEXT_PUBLIC_WAP_SHOW_FB_GROUP,
    NEXT_PUBLIC_WEB_SHOW_FB_GROUP: process.env.NEXT_PUBLIC_WEB_SHOW_FB_GROUP,
    NEXT_PUBLIC_FB_GROUP_IMG: process.env.NEXT_PUBLIC_FB_GROUP_IMG,
    NEXT_PUBLIC_SHOW_DOWNLOAD_APP: process.env.NEXT_PUBLIC_SHOW_DOWNLOAD_APP,
    NEXT_PUBLIC_PD_RULE_PDF: process.env.NEXT_PUBLIC_PD_RULE_PDF,
    NEXT_PUBLIC_ZEELOOL_REWARDS_SHOP_NOW_BTN: process.env.NEXT_PUBLIC_ZEELOOL_REWARDS_SHOP_NOW_BTN,
    NEXT_PUBLIC_ZEELOOL_REWARDS_SHOP_NOW_LINK:
      process.env.NEXT_PUBLIC_ZEELOOL_REWARDS_SHOP_NOW_LINK,
    NEXT_PUBLIC_MARKET_EMAIL: process.env.NEXT_PUBLIC_MARKET_EMAIL,
    NEXT_PUBLIC_COOKIE_TARGET: process.env.NEXT_PUBLIC_COOKIE_TARGET,
    NEXT_PUBLIC_PAY_CENTER_SITE_NAME: process.env.NEXT_PUBLIC_PAY_CENTER_SITE_NAME,
    NEXT_PUBLIC_SHOW_KLARNA: process.env.NEXT_PUBLIC_SHOW_KLARNA,
    NEXT_PUBLIC_SITE_LANG: process.env.NEXT_PUBLIC_SITE_LANG,
    NEXT_PUBLIC_FACEBOOK_MESSAGE_APP_ID: process.env.NEXT_PUBLIC_FACEBOOK_MESSAGE_APP_ID,
    NEXT_PUBLIC_ENABLE_CLIENT_LOGGER: process.env.NEXT_PUBLIC_ENABLE_CLIENT_LOGGER,
    NEXT_PUBLIC_LOG_LEVEL: process.env.NEXT_PUBLIC_LOG_LEVEL,
    NEXT_PUBLIC_LOG_PREFIX: process.env.NEXT_PUBLIC_LOG_PREFIX,
    NEXT_PUBLIC_GOOGLE_BADGE_ID: process.env.NEXT_PUBLIC_GOOGLE_BADGE_ID,
    NEXT_PUBLIC_ENABLE_IMPACT_RADIUS: process.env.NEXT_PUBLIC_ENABLE_IMPACT_RADIUS,
    NEXT_PUBLIC_S3_FOLDER: process.env.NEXT_PUBLIC_S3_FOLDER,
    NEXT_PUBLIC_SHOW_CONTACT_US: process.env.NEXT_PUBLIC_SHOW_CONTACT_US,
    NEXT_PUBLIC_SHOW_AFTER_PAY: process.env.NEXT_PUBLIC_SHOW_AFTER_PAY,
    NEXT_PUBLIC_TONG_DUN_PARTNER_ID: process.env.NEXT_PUBLIC_TONG_DUN_PARTNER_ID,
    NEXT_PUBLIC_TONG_DUN_BASE_URL: process.env.NEXT_PUBLIC_TONG_DUN_BASE_URL,
    NEXT_PUBLIC_TONG_DUN_SITE_KEY: process.env.NEXT_PUBLIC_TONG_DUN_SITE_KEY,
    NEXT_PUBLIC_ENABLE_GOOGLE_TRANSLATE: process.env.NEXT_PUBLIC_ENABLE_GOOGLE_TRANSLATE,
    NEXT_PUBLIC_ENABLE_RTB_HOUSE: process.env.NEXT_PUBLIC_ENABLE_RTB_HOUSE,
    NEXT_PUBLIC_RTB_HOUSE_ID: process.env.NEXT_PUBLIC_RTB_HOUSE_ID,
    NEXT_PUBLIC_RTB_HOUSE_DATA_CENTER: process.env.NEXT_PUBLIC_RTB_HOUSE_DATA_CENTER,
    NEXT_PUBLIC_ENCRYPT_CODE: process.env.NEXT_PUBLIC_ENCRYPT_CODE,
    NEXT_PUBLIC_ENABLE_AWIN: process.env.NEXT_PUBLIC_ENABLE_AWIN,
    NEXT_PUBLIC_AWIN_MERCHANT: process.env.NEXT_PUBLIC_AWIN_MERCHANT,

    NEXT_PUBLIC_AWS_WAF_CHALLENGE_SDK_URL: process.env.NEXT_PUBLIC_AWS_WAF_CHALLENGE_SDK_URL,
    NEXT_PUBLIC_AWS_WAF_CAPTCHA_SDK_URL: process.env.NEXT_PUBLIC_AWS_WAF_CAPTCHA_SDK_URL,
    NEXT_PUBLIC_AWS_WAF_API_KEY: process.env.NEXT_PUBLIC_AWS_WAF_API_KEY,
    NEXT_PUBLIC_ENABLE_AWS_WAF: process.env.NEXT_PUBLIC_ENABLE_AWS_WAF,
    NEXT_PUBLIC_ZENDESK_KEY: process.env.NEXT_PUBLIC_ZENDESK_KEY,
    NEXT_PUBLIC_ENABLE_CONSENT_MANAGER: process.env.NEXT_PUBLIC_ENABLE_CONSENT_MANAGER,
    NEXT_PUBLIC_CONSENT_MANAGER_CDID: process.env.NEXT_PUBLIC_CONSENT_MANAGER_CDID,
    NEXT_PUBLIC_GA4_PURCHASE: process.env.NEXT_PUBLIC_GA4_PURCHASE,
    NEXT_PUBLIC_GA4_ADD_TO_CART: process.env.NEXT_PUBLIC_GA4_ADD_TO_CART,
    NEXT_PUBLIC_GA4_GOODS_DETAIL: process.env.NEXT_PUBLIC_GA4_GOODS_DETAIL,
    NEXT_PUBLIC_FULL_LOCALE: process.env.NEXT_PUBLIC_FULL_LOCALE,
    NEXT_PUBLIC_URL: process.env.NEXT_PUBLIC_URL,
    NEXT_PUBLIC_FULL_SITE_NAME: process.env.NEXT_PUBLIC_FULL_SITE_NAME,
    NEXT_PUBLIC_FULL_URL: process.env.NEXT_PUBLIC_FULL_URL,
    NEXT_PUBLIC_SUPPORT_EMAIL: process.env.NEXT_PUBLIC_SUPPORT_EMAIL,
    NEXT_PUBLIC_AFFILIATE_EMAIL: process.env.NEXT_PUBLIC_AFFILIATE_EMAIL,
    NEXT_PUBLIC_PUBLIC_RELATION_EMAIL: process.env.NEXT_PUBLIC_PUBLIC_RELATION_EMAIL,
    NEXT_PUBLIC_CUSTOMER_SERVICE_TIME: process.env.NEXT_PUBLIC_CUSTOMER_SERVICE_TIME,
    NEXT_PUBLIC_HAS_APP: process.env.NEXT_PUBLIC_HAS_APP,
    NEXT_PUBLIC_ENABLE_SHAREASALE: process.env.NEXT_PUBLIC_ENABLE_SHAREASALE,
    NEXT_PUBLIC_SHAREASALE_MERCHANT_ID: process.env.NEXT_PUBLIC_SHAREASALE_MERCHANT_ID,
    NEXT_PUBLIC_GOOGLE_PAY_MERCHANT_ID: process.env.NEXT_PUBLIC_GOOGLE_PAY_MERCHANT_ID,
    NEXT_PUBLIC_GOOGLE_GATEWAY_MERCHANT_ID: process.env.NEXT_PUBLIC_GOOGLE_GATEWAY_MERCHANT_ID,
    NEXT_PUBLIC_APPLE_PAY_MERCHANT_ID: process.env.NEXT_PUBLIC_APPLE_PAY_MERCHANT_ID,
    NEXT_PUBLIC_TWITTER_NAME: process.env.NEXT_PUBLIC_TWITTER_NAME,
    NEXT_PUBLIC_KLARNA_TYPE: process.env.NEXT_PUBLIC_KLARNA_TYPE,

    // arms用户体验监控sdk
    NEXT_PUBLIC_ARMS_PID: process.env.NEXT_PUBLIC_ARMS_PID,
    NEXT_PUBLIC_ARMS_ENDPOINT: process.env.NEXT_PUBLIC_ARMS_ENDPOINT,
    NEXT_PUBLIC_ENABLE_ARMS: process.env.NEXT_PUBLIC_ENABLE_ARMS,
    NEXT_PUBLIC_FULL_COUNTRY_NAME: process.env.NEXT_PUBLIC_FULL_COUNTRY_NAME,
  },
});
